module.exports = __webpack_public_path__ + "img/sort-amount-up.d22723ca.svg";